import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from "react-bootstrap";
import { omit } from 'lodash';

export default class ActionsDropdown extends React.Component {
  static propTypes = {
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    selectedId: PropTypes.number,
    onAddToGroup: PropTypes.func.isRequired,
    onCreateGroup: PropTypes.func.isRequired,
    onDeleteFromGroup: PropTypes.func.isRequired
  };

  render() {
    const dropdownProps = omit(this.props, Object.keys(ActionsDropdown.propTypes));
    return (
      <Dropdown className='actions-dropdown borderless' id='actions-dropdown' {...dropdownProps}>
        <Dropdown.Toggle>
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <React.Fragment>
            <MenuItem key='create-group' onClick={this.props.onCreateGroup}>Create Group</MenuItem>
          </React.Fragment>
          {this.renderAddToGroupSection()}
          {this.renderDeleteFromGroupSection()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderAddToGroupSection() {
    const {
      groups,
      selectedId,
      onAddToGroup
    } = this.props;

    if (groups && groups.length > 0) {
      let groupOptions = groups.map((group) => {
        const ids = group.personIds;
        if (!(ids.some(id=> selectedId === id))) {
          return (
            <MenuItem
              eventKey={group}
              key={group.id}
              onSelect={onAddToGroup}
            >
              {group.name}
            </MenuItem>
          );
        }
      });
      groupOptions = groupOptions.filter(Boolean);

      if (groupOptions.length > 0) {
        return (
          <React.Fragment>
            <MenuItem divider />
            <MenuItem header>Add to Group</MenuItem>
            {groupOptions}
          </React.Fragment>
        );
      }
    }
  }

  renderDeleteFromGroupSection() {
    const {
      groups,
      selectedId,
      onDeleteFromGroup
    } = this.props;

    if (groups && groups.length > 0) {
      const groupOptions = groups.map((group) => {
        const ids = group.personIds;
        if (ids.some(id=> selectedId === id)) {
          return (
            <MenuItem
              eventKey={group}
              key={group.id}
              onSelect={onDeleteFromGroup}
            >
              {group.name}
            </MenuItem>
          );
        }
      });

      if (groupOptions.filter(Boolean).length > 0)
        return (
          <React.Fragment>
            <MenuItem divider />
            <MenuItem header>Delete from Group</MenuItem>
            {groupOptions}
          </React.Fragment>
        );
    }
  }
}
